// extracted by mini-css-extract-plugin
export default {"tableContainer":"shipmentOfPickups_tableContainer__PUG1k","contentTable":"shipmentOfPickups_contentTable__GpRdE","button":"shipmentOfPickups_button__pr8iX"};